export * from './wall-type-1.component'